import React, { useEffect, useState } from "react";
import api, { API } from "@/lib/api";

/**
 * Auth-aware image loader: fetches via Bearer token, returns a blob URL.
 * Falls back to placeholder text if unauthorized or 404.
 */
export default function AuthImage({ path, alt = "", className = "", testid }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let url;
    (async () => {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        url = URL.createObjectURL(res.data);
        if (!cancelled) setSrc(url);
      } catch (e) {
        if (!cancelled) setErr(true);
      }
    })();
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (err) {
    return <div data-testid={testid} className={`${className} flex items-center justify-center text-xs text-[var(--text-3)] bg-[var(--surface-2)]/50`}>Vorschau nicht verfügbar</div>;
  }
  if (!src) {
    return <div data-testid={testid} className={`${className} flex items-center justify-center text-xs text-[var(--text-3)] bg-[var(--surface-2)]/50 animate-pulse`}>Lade…</div>;
  }
  return <img data-testid={testid} src={src} alt={alt} className={className} />;
}
